import {RouteObject} from 'react-router';

// Public-facing appearance routes. The preview route renders the active theme's
// homepage blocks dynamically (Phase 1 verification). Admin builder/options
// routes will be added under the admin section in later phases.
export const appearanceRoutes: RouteObject[] = [
  {
    path: 'appearance/preview',
    lazy: () => import('@app/appearance/appearance-preview-page'),
  },
];
